module.exports = __webpack_public_path__ + "img/dan-at-desk.7d2889eb.jpg";